import React, { useEffect, useMemo } from 'react';
import { Flex } from 'antd';
import { Outlet } from 'react-router-dom';

import { useLazyReadOrdersQuery } from '../service/orders';
import { OrdersFilters, OrdersProps } from '../interface/orders.interface';
import { ExportsButton } from '../../exports/components/ExportsButton';
import { OrdersTable } from '../components/OrdersTable';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';
import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import {
    CommonFiltersProps,
    CommonTableProps,
} from '../../../interfaces/common.interface';
import { FETCH_DELAY } from '../../../utils/common';
import { TableTitle } from '../../../views/Common/TableTitle';
import { useAppSelector } from '../../../../../store';

export const OrdersContainer = () => {
    const current = useAppSelector(selectShopCurrent);

    const {
        updateFilters,
        filters,
        get,
        source,
        loading,
        getColumnSearchProps,
    } = useFilters<OrdersFilters, OrdersProps>(useLazyReadOrdersQuery, null);

    const tableProps = useMemo<
        CommonTableProps<OrdersProps, CommonFiltersProps>
    >(
        () => ({
            loading,
            source,
            filters,
            updateFilters,
            getColumnSearchProps,
        }),
        [loading, source, filters, updateFilters, getColumnSearchProps]
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (current.id) {
                get({ filters: filters, id: current.id }, true);
            }
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, get, current]);

    return (
        <Flex gap={24} vertical>
            <TableTitle title={'История заказов'}>
                <ExportsButton />
            </TableTitle>
            <OrdersTable {...tableProps} />
            <Outlet />
        </Flex>
    );
};
